import { ALL_TIME_DATE_RANGE } from 'client/js/main/constants';
import { deepCopy } from '../../../../../../shared/utils/deepCopy';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import type { Filters, QrCodeLinkManagerFilterState } from '../types';

export const INIT_FILTERS: Filters = {
  createdDateRange: {
    type: ALL_TIME_DATE_RANGE.type,
    dateRange: ALL_TIME_DATE_RANGE.getValue(),
  },
  archived: false,
  campaign: [],
  feature: [],
  channel: [],
  tags: [],
};

export const INIT_STATE: WrappedReducer<QrCodeLinkManagerFilterState> = {
  loadingStatus: 0,
  loading: false,
  error: undefined,
  searchString: '',
  filterEditor: deepCopy({ ...INIT_FILTERS }),
  appliedFilters: deepCopy({ ...INIT_FILTERS }),
};
